import { Checkbox, Button } from '@sentara-health/optimahealth_web';
import { AuthorizationAccessType } from './AuthorizationModalConsent';

type DependentAccessCheckboxProps = {
  accessType: AuthorizationAccessType;
  label: string;
  dependentAccess: boolean;
  onAccessChange: (isChecked: boolean, accessType: AuthorizationAccessType) => void;
  onViewTerms: (accessType: AuthorizationAccessType) => void;
  viewTermsLabel: string;
  viewTermsDataTestId: string;
  showViewTerms: boolean;
  className?: string;
};

/**
 * Shared UI for the "allow dependent access" checkbox with an inline
 * "View Terms" link. The consent flow logic lives in useDependentConsent.
 */
const DependentAccessCheckbox: React.FC<DependentAccessCheckboxProps> = ({
  accessType,
  label,
  dependentAccess,
  onAccessChange,
  onViewTerms,
  viewTermsLabel,
  viewTermsDataTestId,
  showViewTerms,
  className = 'd-flex align-items-center mb-4 p-0',
}) => {
  const isSpouse = accessType === 'spouse';
  const id = isSpouse ? 'spouseAllowAccess' : 'parentAllowAccess';
  const checkboxDataTestId = isSpouse
    ? 'spouseAllowAccessCheckbox'
    : 'parentAllowAccessCheckbox';

  return (
    <div className={className}>
      <Checkbox
        id={id}
        type="checkbox"
        value={dependentAccess}
        dataTestId={checkboxDataTestId}
        checked={dependentAccess}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onAccessChange(e.target.checked, accessType)
        }
      >
        <div className="d-flex align-items-center justify-content-between gap-3">
          <span>{label}</span>
          {showViewTerms && (
            <Button
              type="button"
              variant="link_btn"
              className="p-0 text-decoration-underline"
              onClick={(e: any) => {
                e.preventDefault();
                e.stopPropagation();
                onViewTerms(accessType);
              }}
              dataTestId={viewTermsDataTestId}
            >
              {viewTermsLabel}
            </Button>
          )}
        </div>
      </Checkbox>
    </div>
  );
};

export default DependentAccessCheckbox;
